import { graphql } from 'gql.tada'

export const DepositPlatformsListDocument = graphql(`
  query DepositPlatformsList {
    deposit_platforms(
      order_by: [{ department_code: asc }, { commune: asc }]
    ) {
      locality
      commune
      department_code
      platform_url
      notes
      created
      updated
    }
  }
`)

export const DepositPlatformByLocalityDocument = graphql(`
  query DepositPlatformByLocality($locality: String!) {
    deposit_platforms_by_pk(locality: $locality) {
      locality
      commune
      department_code
      platform_url
      notes
      updated
    }
  }
`)

export const DepositPlatformUpdateDocument = graphql(`
  mutation DepositPlatformUpdate(
    $locality: String!
    $set: deposit_platforms_set_input!
  ) {
    update_deposit_platforms_by_pk(
      pk_columns: { locality: $locality }
      _set: $set
    ) {
      locality
      platform_url
      notes
      updated
    }
  }
`)

export const DepositPlatformUpsertDocument = graphql(`
  mutation DepositPlatformUpsert($object: deposit_platforms_insert_input!) {
    insert_deposit_platforms_one(
      object: $object
      on_conflict: {
        constraint: deposit_platforms_pkey
        update_columns: [commune, department_code, platform_url, notes]
      }
    ) {
      locality
      commune
      department_code
      platform_url
      notes
      updated
    }
  }
`)
